import { render } from "./UseCasesTable.vue?vue&type=template&id=1b9f7513&scoped=true"
import script from "./UseCasesTable.vue?vue&type=script&lang=js"
export * from "./UseCasesTable.vue?vue&type=script&lang=js"

import "./UseCasesTable.vue?vue&type=style&index=0&id=1b9f7513&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9f7513"]])

export default __exports__